import React from "react";
import { useActionRequest } from "../../../common/hooks/api";
import { useSurvey } from "../../../common/hooks/api/useSurvey";
import { Api } from "../../../common/service/Api";
import { LawfulBasis } from "../../../common/service/server/dto/ProcessingActivityDto";
import { PageHeader } from "../../components/layout/header/Header";
import { StandardPageWrapper } from "../../components/layout/StandardPageWrapper";
import { AddProcessingActivityDialog } from "../../components/organisms/AddProcessingActivityDialog";
import { ProcessingActivitySettingsTable } from "../../components/organisms/ProcessingActivitySettingsTable";
import { usePrimaryOrganizationId } from "../../hooks";
import { useProcessingActivites } from "../../hooks/useProcessingActivities";
import { Routes } from "../../root/routes";
import { ProgressFooter, ProgressFooterActions } from "../get-compliant/ProgressFooter";
import {
  EEA_UK_SURVEY_NAME,
  EXTRA_LAWFUL_BASES_PUBLIC_INTEREST_SLUG,
  EXTRA_LAWFUL_BASES_VITAL_INTEREST_SLUG,
} from "../../surveys/eeaUkSurvey";
import { LawfulBasisExtendedOptionsVisibility } from "../../components/organisms/ProcessingActivityLawfulBasisSelect";

export const LawfulBasesDetailPage = () => {
  const orgId = usePrimaryOrganizationId();
  const { answers: eeaUkAnswers, request: surveyRequest } = useSurvey(orgId, EEA_UK_SURVEY_NAME);
  const [activities, activityRequest, refreshActivities] = useProcessingActivites(orgId);

  let extendedOptionsVisibility: LawfulBasisExtendedOptionsVisibility = {
    PUBLIC_INTEREST: eeaUkAnswers[EXTRA_LAWFUL_BASES_PUBLIC_INTEREST_SLUG] === "true",
    VITAL_INTEREST_OF_INDIVIDUAL: eeaUkAnswers[EXTRA_LAWFUL_BASES_VITAL_INTEREST_SLUG] === "true",
  };

  const { fetch: updateLawfulBasis } = useActionRequest({
    api: ({ activityId, bases }: { activityId: string; bases: LawfulBasis[] }) =>
      Api.processingActivities.patchUpdateProcessingActivity(orgId, activityId, {
        name: undefined,
        lawfulBases: bases,
        regions: undefined,
      }),
    onSuccess: () => refreshActivities(),
  });

  const footer = (
    <ProgressFooter
      actions={<ProgressFooterActions nextContent="Done" nextUrl={Routes.dataMap.root} />}
    />
  );

  return (
    <StandardPageWrapper requests={[surveyRequest, activityRequest]} footer={footer}>
      <PageHeader titleContent="Lawful Bases" />

      <div className="mb-md">
        <ProcessingActivitySettingsTable
          activities={activities}
          onChange={updateLawfulBasis}
          extendedOptionsVisibility={extendedOptionsVisibility}
          onRemove={async () => await refreshActivities()}
        />
      </div>

      <AddProcessingActivityDialog
        existingActivities={activities}
        orgId={orgId}
        onAdd={() => {
          refreshActivities();
        }}
      />
    </StandardPageWrapper>
  );
};
